'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  padding: ', 'px 10px;\n  text-align: center;\n'], ['\n  width: 100%;\n  padding: ', 'px 10px;\n  text-align: center;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Heading = require('../../Heading/Heading');

var _Heading2 = _interopRequireDefault(_Heading);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Components


var Container = _styledComponents2.default.div(_templateObject, function (_ref) {
  var small = _ref.small;
  return small ? 50 : 100;
});

var NotFound = function NotFound(_ref2) {
  var children = _ref2.children,
      small = _ref2.small;
  return _react2.default.createElement(Container, {
    small: small
  }, _react2.default.createElement(_Heading2.default, {
    size: '5',
    grey: true
  }, children));
};

NotFound.propTypes = {
  children: _propTypes2.default.node,
  small: _propTypes2.default.bool
};
NotFound.defaultProps = {
  small: false
};
exports.default = NotFound;